import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ballotListRoute } from '../route-names';
import { BallotListService } from '../ballot-list/ballot-list.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SessionService } from '../Services/session.service';
import { ConfirmationType } from '../backend-types/misc-types';

import '@angular/localize/init'
import { EventType } from '../ballot/ballot.service';
@Component({
    selector: 'app-success-page',
    templateUrl: './voting-success.component.html',
    styleUrls: ['./voting-success.component.scss'],
    standalone: false
})
export class VotingSuccessComponent implements OnInit, AfterViewInit {
  confirmationType: ConfirmationType | undefined;
  confirmationId: string | undefined;
  routeName = "";
  ballotType?: EventType;
  recurrence?: string;

  constructor(
    private readonly router: Router,
    private readonly sessionService: SessionService,
    private readonly ballotListService: BallotListService,
    private announcer: LiveAnnouncer,
  ) {
    this.confirmationId = history.state.confirmationId;
    this.confirmationType = history.state.confirmationType;
    this.ballotType = history.state.ballotType;
    this.recurrence = history.state.recurrence;
  }

  ngOnInit(): void {    
    if (this.ballotType === 'PETITION') {
      this.announcer.announce($localize`Your petition has been successfully submitted.`);
    } else if(this.ballotType === 'POLL') {
      this.announcer.announce($localize`Your poll has been successfully submitted.`);
    } else {
      this.announcer.announce($localize`Your ballot has been successfully submitted.`);
    }
    if (this.confirmationType?.includes('ONSCREEN')) {
      this.announcer.announce($localize`Your confirmation id is ` + this.confirmationId);
     }
  }
  ngAfterViewInit() {

    setTimeout(() => {
      this.routeName = this.router.url
      this.resetFocus()
    }, 100);
  }

  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    let focusFieldMobile = document.getElementById('accessibility-button-mobile')

    if (focusField) {
      focusField.focus()
    }

    if (focusFieldMobile) {
      focusFieldMobile.focus()
    }
  }

  get hasMoreBallots(): boolean {
    return this.ballotListService.getBallots().length > 0
  }

  continue() {
    this.router.navigate(ballotListRoute)
  }

  print(): void {
    window.print()
  }

  exit(): void {
    this.sessionService.finishedVoting()
  }

  emailUsed(): boolean {
    return this.confirmationType?.includes('EMAIL') ?? false;
  }

  spaceOut(text?: string) {
    return text ? text.split('').join(' ') : "";
  }
}
